export function suggestLoginname(vorname = '', nachname = '') {
  const first = vorname.trim();
  const last = nachname.trim();
  if (!first || !last) return '';
  return `${Array.from(first)[0]}${last}`.toLowerCase()
    .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\p{L}\p{N}-]/gu, '').slice(0, 50);
}
